module.exports = __webpack_public_path__ + "assets/4-sales-director-salary-information.93e16eb5.png";